<template>
  <div v-if="visible" :class="['message-toast', type]" @click="hide">
    <div class="message-content">
      <span class="message-icon">{{ icon }}</span>
      <span class="message-text">{{ text }}</span>
    </div>
  </div>
</template>

<script>
let toastTimer = null;

export default {
  name: 'MessageToast',
  data() {
    return {
      visible: false,
      text: '',
      type: 'info', // success, error, warning, info
      duration: 3000
    }
  },
  computed: {
    icon() {
      const icons = {
        success: '✓',
        error: '✕',
        warning: '⚠',
        info: 'ℹ'
      }
      return icons[this.type] || icons.info
    }
  },
  methods: {
    show(text, type = 'info', duration = 3000) {
      this.text = text
      this.type = type
      this.duration = duration
      this.visible = true
      
      // 清除之前的定时器
      if (toastTimer) {
        clearTimeout(toastTimer)
      }
      
      // 自动隐藏
      if (duration > 0) {
        toastTimer = setTimeout(() => {
          this.hide()
        }, duration)
      }
    },
    hide() {
      this.visible = false
      if (toastTimer) {
        clearTimeout(toastTimer)
        toastTimer = null
      }
    }
  }
}
</script>

<style scoped>
.message-toast {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  min-width: 200px;
  max-width: 400px;
  padding: 12px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
  animation: slideDown 0.3s ease-out;
  cursor: pointer;
  user-select: none;
  backdrop-filter: blur(10px);
}

.message-toast.success {
  background: rgba(10, 25, 41, 0.9);
  color: #00ff88;
  border: 1px solid rgba(0, 255, 136, 0.5);
  box-shadow: 0 4px 20px rgba(0, 255, 136, 0.2);
}

.message-toast.error {
  background: rgba(10, 25, 41, 0.9);
  color: #ff3366;
  border: 1px solid rgba(255, 51, 102, 0.5);
  box-shadow: 0 4px 20px rgba(255, 51, 102, 0.2);
}

.message-toast.warning {
  background: rgba(10, 25, 41, 0.9);
  color: #ffaa00;
  border: 1px solid rgba(255, 170, 0, 0.5);
  box-shadow: 0 4px 20px rgba(255, 170, 0, 0.2);
}

.message-toast.info {
  background: rgba(10, 25, 41, 0.9);
  color: #00d4ff;
  border: 1px solid rgba(0, 212, 255, 0.5);
  box-shadow: 0 4px 20px rgba(0, 212, 255, 0.2);
}

.message-content {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
}

.message-icon {
  font-size: 16px;
  font-weight: bold;
  min-width: 16px;
}

.message-text {
  flex: 1;
  line-height: 1.4;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .message-toast {
    top: 10px;
    left: 10px;
    right: 10px;
    transform: none;
    max-width: none;
    min-width: auto;
  }
  
  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
}
</style>
